import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const RequireLogin = (Component) => {
  const LoginComponent = (props) => {
    const navigate = useNavigate();
    const token = Cookies.get("hippocratic_portal_token");

    useEffect(() => {
      if (!token) {
        navigate("/Login");
      }
    }, [token, navigate]);

    if (!token) {
      return null;
    } else {
      return <Component {...props} />;
    }
  };

  return LoginComponent;
};

export default RequireLogin;
